<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<sf-button v-if="isButton_(scrId, 'CU')" size="lg" color="default" :line="false" :onClick="Save">{{
				getMessage_('SWCC000327')
			}}</sf-button>
		</template>
		<template v-slot:content>
			<center-content ref="content" :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import CenterContent from './Content/Content.vue';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		CenterContent
	},
	data() {
		return {
			screen: {},
			title: '사용자 그룹 매핑 관리',
			faivorite: true
		};
	},

	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Save() {
			this.$refs.content.$refs.groupTable.saveClick();
		},
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
